module.exports = __webpack_public_path__ + "static/fugyep-2-9b9813e59d450740dfd545dafa1ccc28.png";